module.exports = __webpack_public_path__ + "static/media/psm_question.88db0e60.mp3";